import React from "react"

import { bool, func, arrayOf, shape, string, object, number } from "prop-types"

import { useIs3dPrintModel } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'

import DescriptionForm from "./Components/DescriptionForm/DescriptionForm"
import FileUploadSection from "./Components/FileUploadSection/FileUploadSection"
import MaterialAndResultForm from "./Components/MaterialAndResultForm/MaterialAndResultForm"
import Notification from "./Components/Notification/Notification"
import PrinterUsedForm from "./Components/PrinterUsedForm/PrinterUsedForm"
import TechnicalDetailsSection from "./Components/TechnicalDetailsSection/TechnicalDetailsSection"
import { useCaseShape } from "../../Utils/propTypes"

function UseCaseFormSection({
  // Form hook
  control,
  pendingMedia,
  slicerFile = null,

  handleFilesAdded,
  handleEmbedAdded,
  handleRemoveMedia,
  handleReorderMedia,
  handleSlicerFileSelect,
  handleSlicerFileRemove,

  printerTypeOptions,
  isFetchingPrinterTypes,
  useCases,

  // UI state
  isProcessing,
  progress,
  notification,
  showNotification,
  hideNotification,
  userHavePermissions,
}) {
  const is3dPrintModel = useIs3dPrintModel()

  return (
    <div className="use-cases-area__main-container">
      {notification.show && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={hideNotification}
        />
      )}

      <FileUploadSection
        onFilesAdded={handleFilesAdded}
        onEmbedAdded={handleEmbedAdded}
        pendingMedia={pendingMedia}
        onRemoveMedia={handleRemoveMedia}
        onReorderMedia={handleReorderMedia}
        isProcessing={isProcessing}
        progress={progress}
        useCases={useCases}
        onShowNotification={showNotification}
      />

      {is3dPrintModel && (
        <>
          <div className="use-cases-area__form-row">
            <PrinterUsedForm
              control={control}
              printerTypeOptions={printerTypeOptions}
              isFetchingPrinterTypes={isFetchingPrinterTypes}
              userHavePermissions={userHavePermissions}
            />

            <MaterialAndResultForm
              control={control}
              userHavePermissions={userHavePermissions}
            />
          </div>

          <DescriptionForm
            control={control}
            disabled={!userHavePermissions}
          />

          <TechnicalDetailsSection
            control={control}
            slicerFile={slicerFile}
            handleSlicerFileSelect={handleSlicerFileSelect}
            handleSlicerFileRemove={handleSlicerFileRemove}
            showNotification={showNotification}
            userHavePermissions={userHavePermissions}
          />
        </>
      )}

      {!is3dPrintModel && (
        <DescriptionForm
          control={control}
          disabled={!userHavePermissions}
        />
      )}
    </div>
  )
}

UseCaseFormSection.propTypes = {
  // Form hook
  control: object.isRequired,
  pendingMedia: arrayOf(object).isRequired,
  slicerFile: object,

  // Handlers
  handleFilesAdded: func.isRequired,
  handleEmbedAdded: func.isRequired,
  handleRemoveMedia: func.isRequired,
  handleReorderMedia: func.isRequired,
  handleSlicerFileSelect: func.isRequired,
  handleSlicerFileRemove: func.isRequired,

  printerTypeOptions: arrayOf(object).isRequired,
  isFetchingPrinterTypes: bool.isRequired,
  useCases: arrayOf(useCaseShape).isRequired,

  // UI state
  isProcessing: bool.isRequired,
  progress: shape({
    completed: number.isRequired,
    total: number.isRequired,
    percentage: number.isRequired,
  }).isRequired,
  notification: shape({
    show: bool.isRequired,
    message: string,
    type: string,
  }).isRequired,
  showNotification: func.isRequired,
  hideNotification: func.isRequired,
  userHavePermissions: bool.isRequired,
}

export default UseCaseFormSection
